import { emailRegEx } from 'constants/validation'

const validate = values => {
  const errors = {}

  if (values.reason === '_initial') {
    errors.reason = 'Please choose contact reason'
  }

  if (!values.name) {
    errors.name = 'Name required'
  }

  if (!values.subject) {
    errors.subject = 'Subject required'
  }

  if (!values.message) {
    errors.message = 'Message required'
  }

  if (!values.email) {
    errors.email = 'Email required'
  } else if (!emailRegEx.test(values.email)) {
    errors.email = 'Invalid email address'
  }

  return errors
}

export default validate
